/** @jsx jsx */
import { jsx, Box } from "theme-ui"

export default function PageLayout({ children, ...props }) {
  return (
    <Box {...props}
      sx={{
        borderRadius: 4,
        px: [2, null, 5],
        py: 4,
        bg: 'muted'
      }}
    >
      {children}
    </Box>
  )
}
